module.exports = __webpack_public_path__ + "static/media/recidiviz-logo-light.b6d854d8.svg";